import React from 'react';

const Header = ({
  className = '',
  children,
  style,
  bg: {
    cover,
    left,
    right,
    color,
  } = {},
}) => (
  <header
    className={`
      d-flex position-relative ${className}
      min-vh-30
    `}
    style={{
      ...style,
      ...color ? { backgroundColor: color } : {},
    }}
  >
    {cover && (
      <div
        className="img-bg-cover"
        style={{ backgroundImage: `url(${cover})` }}
      />
    )}
    {(left || right) && (
      <div className="pos-abs-fill">
        <div className="row h-100 no-gutters justify-content-between">
          <div className="position-relative col-5 col-md-4">
            {left && (
              <div
                className="img-bg-cover bg-pos-rc"
                style={{ backgroundImage: `url(${left})` }}
              />
            )}
          </div>
          <div className="position-relative col-5 col-md-4">
            {right && (
              <div
                className="img-bg-cover bg-pos-lc"
                style={{ backgroundImage: `url(${right})` }}
              />
            )}
          </div>
        </div>
      </div>
    )}
    {children && (
      <div className="w-100 my-auto position-relative">
        {children}
      </div>
    )}
  </header>
);

export default Header;
